import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { CreateAuthString } from '../api/createAuthString'
import { CollectionMediaType } from "../types";
import { useParams } from "react-router-dom";
import { useUserContext } from "../context/UserContext";

const base_url = process.env.REACT_APP_API_URL || ""

export const useFetch = (page: number, collectionId?: string) => {
  const { orgId }: any = useParams();
  const userCtx = useUserContext(); 

  const [loading, setLoading] = useState<boolean>(true);
  const [list, setList] = useState<CollectionMediaType[]>([]);

  const sendQuery = useCallback(async () => {

    try {
      const AuthString = CreateAuthString(true)

      let isAdmin = false

      if (userCtx?.loggedInUser) {
        console.log(userCtx.loggedInUser.roles)
        userCtx.loggedInUser.roles.forEach((value) => {
          if (orgId == value["organizationId"]) {
            if (value["roles"].includes("ADMIN")) {
              isAdmin = true
            }
          }
        })
      }
      console.log(isAdmin)

      setLoading(true);
      const res = await axios.get(base_url + '/collection-contributions', { params: {orgId, collectionId, paginationId: page , isAdmin}, headers: { Authorization: AuthString } })
      setList((prev) => [...prev, ...res.data])

      setLoading(false);
    } catch (err) {
      console.error(err)
    }
  }, [page, collectionId]);

  useEffect(() => {
    if (!collectionId) return
    sendQuery();
  }, [sendQuery, page, collectionId]);

  return { loading, list };
}

